import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { fromUnitsToRem, YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const StepMoveToButtonStyle: (isEditingEnabled: boolean) => SxProps<Theme> = (isEditingEnabled) => ({
  position: 'relative',
  marginRight: YodaSpacing.small,
  padding: '9px 10px',
  borderRadius: YodaBorderRadius.xSmall,
  display: 'flex',
  alignItems: 'center',
  cursor: isEditingEnabled ? 'auto' : 'not-allowed',
  pointerEvents: isEditingEnabled ? 'auto' : 'none',

  '&:hover, &:focus': {
    backgroundColor: isEditingEnabled ? YodaColors.gray1 : 'transparent',
    cursor: isEditingEnabled ? 'pointer' : 'not-allowed',
  },

  '& span': {
    fontWeight: YodaFontWeight.medium,
    fontSize: YodaFontSize.small,
    color: isEditingEnabled ? YodaColors.textPrimary : YodaColors.gray2,
  },
});

export const StepMoveToDropdownStyles: SxProps<Theme> = {
  '.MuiMenu-list': {
    maxHeight: '356px',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: 0,
  },

  '.MuiMenu-list > .MuiBox-root': {
    minWidth: '190px',
  },

  '.MuiPaper-root': {
    maxWidth: '190px',
    borderRadius: YodaBorderRadius.small,
    color: YodaColors.black,
    marginTop: fromUnitsToRem(YodaSpacing.xxSmall),
    overflow: 'visible',
    boxShadow: '0px -3px 20px 0px rgba(64, 83, 110, 0.3)',
  },

  '.MuiMenuItem-root': {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: '1.3',
    alignItems: 'flex-start',
    display: 'flex',

    '& .MuiBox-root': {
      color: YodaColors.textPrimary,
      fontSize: YodaFontSize.small,
      fontWeight: YodaFontWeight.regular,
    },

    '&:first-of-type': {
      borderTopLeftRadius: YodaBorderRadius.small,
      borderTopRightRadius: YodaBorderRadius.small,
    },

    '&:last-of-type': {
      borderBottomLeftRadius: YodaBorderRadius.small,
      borderBottomRightRadius: YodaBorderRadius.small,
    },
  },
};

export const RequiredCheckboxStyle: (isEditingEnabled: boolean) => SxProps<Theme> = (isEditingEnabled) => ({
  cursor: isEditingEnabled ? 'auto' : 'not-allowed',
  pointerEvents: isEditingEnabled ? 'auto' : 'none',

  '.MuiCheckbox-root': {
    width: '24px',
    height: '24px',
    marginRight: YodaSpacing.xxSmall,
    color: isEditingEnabled ? YodaColors.blue7 : YodaColors.gray2,
  },

  '.MuiFormControlLabel-label': {
    fontWeight: YodaFontWeight.medium,
    fontSize: YodaFontSize.small,
    color: YodaColors.textPrimary,
  },

  '.MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled': {
    color: YodaColors.gray2,
  },
});

export const DependsOnSelectorStyle: (
  isEditingEnabled: boolean,
  currentStep: number
) => SxProps<Theme> = (
  isEditingEnabled,
  currentStep,
) => ({
  minWidth: '192px',
  fontWeight: YodaFontWeight.medium,
  fontSize: YodaFontSize.small,
  borderRadius: YodaBorderRadius.xSmall,
  cursor: isEditingEnabled && currentStep !== 1 ? 'auto' : 'not-allowed',
  pointerEvents: isEditingEnabled && currentStep !== 1 ? 'auto' : 'none',

  '.MuiOutlinedInput-input.MuiAutocomplete-input': {
    padding: '6px 4px 6px 6px',
    fontWeight: YodaFontWeight.regular,
    fontSize: YodaFontSize.small,
  },

  '.MuiOutlinedInput-input.MuiAutocomplete-input::placeholder': {
    fontWeight: YodaFontWeight.light,
    fontSize: YodaFontSize.small,
    color: YodaColors.textSecondary,
  },

  '.MuiAutocomplete-endAdornment': {
    opacity: currentStep === 1 ? 0.3 : 1,
  },

  '.MuiPaper-root': {
    maxWidth: '190px',
    borderRadius: YodaBorderRadius.small,
    padding: '0',
    color: YodaColors.black,
    marginTop: fromUnitsToRem(YodaSpacing.xxSmall),
    overflow: 'visible',
    boxShadow: '0px -3px 20px 0px rgba(64, 83, 110, 0.3)',

    '& > div': {
      margin: '0',
      padding: '0',
      height: 'auto',
    },

    '& li': {
      margin: '0',
      color: YodaColors.textPrimary,
      fontSize: YodaFontSize.small,
      fontWeight: YodaFontWeight.regular,
      padding: YodaSpacing.small,

      '&:first-of-type': {
        borderTopLeftRadius: YodaBorderRadius.small,
        borderTopRightRadius: YodaBorderRadius.small,
      },

      '&:last-of-type': {
        borderBottomLeftRadius: YodaBorderRadius.small,
        borderBottomRightRadius: YodaBorderRadius.small,
      },

      '&:not(:last-of-type)': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12);',
      },
    },
  },
});
